/**
 * SGI Stone Swatches - colorway card stone/material option picker.
 *
 * @ui @storefront @nav-cards @collection-filter
 *
 * One delegated click listener for EVERY stone swatch row on the page
 * (snippets/sgi-snc-stone-swatches.liquid, rendered under a colorway card by
 * snippets/sgi-snc-card.liquid). Loaded once - the snippet emits the script
 * tag only for the first card that has swatches, and this IIFE latches
 * window.__sgiStoneSwatches so a second tag (two nav-card sections on one
 * page) binds nothing.
 *
 * Clicking a swatch never navigates. It:
 *   1. marks itself pressed (aria-pressed) and clears its siblings,
 *   2. re-points the card's <a class="snc-card"> at the colorway page plus
 *      ?<param>=<label>, preserving every query param already on the card
 *      link (e.g. a nav prefilter) via URLSearchParams,
 *   3. reveals the corner inset of that stone's swatch inside the card image.
 * Clicking the pressed swatch again restores the plain card href and hides
 * the inset.
 *
 * Swiper loop mode clones slides for seamless wrap, so a card can exist as
 * TWO DOM nodes (the original + its clone) sharing the same
 * data-snc-base-href. Only the clicked one's cell is updated directly
 * (cardLinkFor); select() then syncs every OTHER a.snc-card on the page that
 * shares that base href, so a clone never shows a stale href/inset.
 *
 * Contract (markup):
 *   [data-snc-stones]              row root; data-snc-stone-param = filter param
 *   [data-snc-stone]               a button; value = the stone label
 *   [data-snc-stone-img]           swatch CDN url for the inset
 *   a.snc-card[data-snc-base-href] the card link + its unfiltered href
 *   [data-snc-stone-inset]         hidden inset wrapper inside the card link
 *   [data-snc-stone-inset-img]     the <img> inside that wrapper
 *
 * See Also: snippets/sgi-snc-stone-swatches.liquid, snippets/sgi-snc-card.liquid
 */
(function () {
  'use strict';

  if (window.__sgiStoneSwatches) return;
  window.__sgiStoneSwatches = true;

  var ROOT_SEL = '[data-snc-stones]';
  var BTN_SEL = '[data-snc-stone]';
  var DEFAULT_PARAM = 'filter.p.m.filters.stone_option';

  /* The card link and the swatch row are siblings inside the same grid cell
     (<li>) or carousel slide - never look outside that cell, so a Swiper
     loop clone drives its own card and not the original. */
  function cardLinkFor(root) {
    var cell = root.closest('li, .swiper-slide') || root.parentElement;
    return cell ? cell.querySelector('a.snc-card') : null;
  }

  function baseHref(link) {
    var base = link.getAttribute('data-snc-base-href');
    if (!base) {
      base = link.getAttribute('href') || '';
      link.setAttribute('data-snc-base-href', base);
    }
    return base;
  }

  function hrefWith(base, param, value) {
    var url;
    try {
      url = new URL(base, window.location.origin);
    } catch (e) {
      return base;
    }
    url.searchParams.delete(param);
    url.searchParams.append(param, value);
    return url.pathname + url.search + url.hash;
  }

  function paint(root, chosen) {
    var buttons = root.querySelectorAll(BTN_SEL);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i] === chosen ? 'true' : 'false');
    }
  }

  function setInset(link, src, label) {
    var inset = link.querySelector('[data-snc-stone-inset]');
    if (!inset) return;
    var img = inset.querySelector('[data-snc-stone-inset-img]');
    if (!src || !img) {
      inset.hidden = true;
      return;
    }
    img.setAttribute('src', src);
    img.setAttribute('alt', label);
    inset.hidden = false;
  }

  /* Every OTHER a.snc-card sharing this base href is a Swiper loop clone of
     the card just updated (or vice versa) - keep it in lockstep so wrapping
     the carousel never shows a clone with the pre-click href/inset. */
  function syncClones(updated, base, href, imgSrc, label) {
    var all = document.querySelectorAll('a.snc-card[data-snc-base-href]');
    for (var i = 0; i < all.length; i++) {
      var other = all[i];
      if (other === updated || other.getAttribute('data-snc-base-href') !== base) continue;
      other.setAttribute('href', href);
      setInset(other, imgSrc, label);
    }
  }

  function select(root, btn) {
    var wasPressed = btn.getAttribute('aria-pressed') === 'true';
    var link = cardLinkFor(root);
    var param = root.getAttribute('data-snc-stone-param') || DEFAULT_PARAM;
    var label = btn.getAttribute('data-snc-stone') || '';

    paint(root, wasPressed ? null : btn);
    if (!link) return;

    var base = baseHref(link);
    var href = wasPressed ? base : hrefWith(base, param, label);
    var imgSrc = wasPressed ? null : btn.getAttribute('data-snc-stone-img');

    link.setAttribute('href', href);
    setInset(link, imgSrc, label);
    syncClones(link, base, href, imgSrc, label);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest(BTN_SEL);
    if (!btn) return;
    var root = btn.closest(ROOT_SEL);
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    select(root, btn);
  });
})();
